import React from "react";
import styles from "./Settings.module.css";
import { Flex } from "@chakra-ui/react";
import { CloseIcon } from "../../../icons";

const SettingsContent = ({
  onClose,
  children,
}: {
  onClose: () => void;
  children: React.ReactNode;
}) => {
  return (
    <div className={styles.settings__contents__area}>
      <Flex
        p={"15px"}
        justifyContent={"flex-end"}
      >
        <div
          className={styles.settings__close}
          onClick={onClose}
        >
          <CloseIcon
            color="rgba(202, 205, 206, 1)"
            w={4}
            h={4}
          />
        </div>
      </Flex>
      <Flex
        justifyContent={"center"}
        w={"full"}
      >
        {children}
      </Flex>
    </div>
  );
};

export default SettingsContent;
